export default __webpack_public_path__ + "static/media/3.f5d878d6.png";